var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListaW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_4902)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_211_4902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8666 4H7.62548C6.66249 4 5.88184 4.79403 5.88184 5.77351C5.88184 6.753 6.66249 7.54702 7.62548 7.54702H20.8666C21.8296 7.54702 22.6102 6.753 22.6102 5.77351C22.6102 4.79403 21.8296 4 20.8666 4Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48728 5.77351C4.48728 4.79403 3.70663 4 2.74364 4C1.78065 4 1 4.79403 1 5.77351C1 6.753 1.78065 7.54702 2.74364 7.54702C3.70663 7.54702 4.48728 6.753 4.48728 5.77351Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8666 10.6211H7.62548C6.66249 10.6211 5.88184 11.4151 5.88184 12.3946C5.88184 13.3741 6.66249 14.1681 7.62548 14.1681H20.8666C21.8296 14.1681 22.6102 13.3741 22.6102 12.3946C22.6102 11.4151 21.8296 10.6211 20.8666 10.6211Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48728 12.3946C4.48728 11.4151 3.70663 10.6211 2.74364 10.6211C1.78065 10.6211 1 11.4151 1 12.3946C1 13.3741 1.78065 14.1681 2.74364 14.1681C3.70663 14.1681 4.48728 13.3741 4.48728 12.3946Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8666 17.2529H7.62548C6.66249 17.2529 5.88184 18.047 5.88184 19.0264C5.88184 20.0059 6.66249 20.8 7.62548 20.8H20.8666C21.8296 20.8 22.6102 20.0059 22.6102 19.0264C22.6102 18.047 21.8296 17.2529 20.8666 17.2529Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48728 19.0264C4.48728 18.047 3.70663 17.2529 2.74364 17.2529C1.78065 17.2529 1 18.047 1 19.0264C1 20.0059 1.78065 20.8 2.74364 20.8C3.70663 20.8 4.48728 20.0059 4.48728 19.0264Z",
    fill: "#FFFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_4902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_211_4902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 16.8,
    fill: "white",
    transform: "translate(1 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaW);
export default __webpack_public_path__ + "static/media/listaW.449495487e0be7ff13780f62f82a05cf.svg";
export { ForwardRef as ReactComponent };